import { useState } from 'react';

/**
 * Regex 可視化測試器：輸入正則與測試字串，即時顯示匹配與分組
 */
export function RegexTesterTool() {
  const [pattern, setPattern] = useState('');
  const [testString, setTestString] = useState('');
  const [flags, setFlags] = useState('g');

  let regex: RegExp | null = null;
  const matches: RegExpExecArray[] = [];
  let error: string | null = null;
  try {
    if (pattern.trim()) {
      regex = new RegExp(pattern, flags);
      let m: RegExpExecArray | null;
      while ((m = regex.exec(testString)) !== null) {
        matches.push([...m] as RegExpExecArray);
        if (!flags.includes('g')) break;
      }
    }
  } catch (e) {
    error = e instanceof Error ? e.message : '正則表達式語法錯誤';
  }

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
            正則表達式
          </label>
          <div className="flex flex-wrap items-center gap-2">
            <input
              type="text"
              value={pattern}
              onChange={e => setPattern(e.target.value)}
              placeholder="例如：\d+、[a-z]+"
              className="min-w-[200px] flex-1 rounded border border-gray-300 bg-white px-3 py-2 font-mono text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
              aria-label="正則表達式"
            />
            <input
              type="text"
              value={flags}
              onChange={e =>
                setFlags(e.target.value.replace(/[^gimsuy]/gi, ''))
              }
              placeholder="g"
              className="w-20 rounded border border-gray-300 bg-white px-2 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
              aria-label="旗標 g i m s u y"
              title="旗標：g 全域, i 忽略大小寫, m 多行, s dotAll, u unicode, y sticky"
            />
          </div>
        </div>
        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
            測試字串
          </label>
          <textarea
            value={testString}
            onChange={e => setTestString(e.target.value)}
            placeholder="輸入要匹配的文字..."
            rows={4}
            className="w-full rounded border border-gray-300 bg-white px-3 py-2 font-mono text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            aria-label="測試字串"
          />
        </div>
        {error && (
          <p
            className="mb-3 text-sm text-red-600 dark:text-red-400"
            role="alert"
          >
            {error}
          </p>
        )}
      </div>

      <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          匹配結果
        </h2>
        {regex && (
          <div className="space-y-2 text-sm">
            <p className="text-gray-600 dark:text-gray-400">
              共 {matches.length} 個匹配
            </p>
            {matches.length > 0 ? (
              <ul className="space-y-2 font-mono">
                {matches.map((m, i) => (
                  <li
                    key={i}
                    className="rounded border border-gray-200 bg-white p-2 dark:border-gray-600 dark:bg-gray-700"
                  >
                    <span className="text-primary">[{i}]</span> {m[0]}
                    {m.length > 1 && (
                      <div className="mt-1 ml-4 text-gray-500 dark:text-gray-400">
                        {m.slice(1).map((g, j) => (
                          <div key={j}>
                            組 {j + 1}: {g ?? '(undefined)'}
                          </div>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 dark:text-gray-400">無匹配</p>
            )}
          </div>
        )}
        {!pattern.trim() && (
          <p className="text-gray-500 dark:text-gray-400">
            請輸入正則表達式與測試字串
          </p>
        )}
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          輸入正則表達式與旗標（g 全域、i 忽略大小寫、m
          多行等），在測試字串中即時顯示所有匹配與捕獲組。適用於除錯與驗證正則。
        </p>
      </section>
    </>
  );
}
